import { PreviewSend, Selected } from '../../styled';
import { Avatar } from '../../../../components';
import { RiContactsBook2Line } from 'react-icons/ri';
import LoadingSend from '../LoadingSend';

const SendStep = ({ 
    template, 
    destiny, 
    checkbox1, 
    setCheckbox1, 
    loading 
}) => {
    return (
        <div className="content">
            {!loading ? (
                <PreviewSend>
                    <div>
                        <span> Enviar : </span>
                    </div>
                    <div className='message'>
                        {template?.text ? template?.text : template?.textFormatted}
                    </div>
                    <span className='checkbox'>
                        <input 
                            type='checkbox' 
                            checked={checkbox1}
                            onChange={() => setCheckbox1(!checkbox1)} 
                        />
                        <label> manter atendimento aberto</label>
                    </span>
                    <label>Para :</label>
                    <div className='destiny'>
                        <Selected style={{ maxHeight: '13rem', border: 'none' }}>
                            {destiny?.length > 0 &&
                                destiny?.map((item) => (
                                    <li key={`${item.id}${item.number_client}${item.descricao}`}>
                                        <span className='avatar--'>
                                            <span className='avatar--list'>
                                                {item?.number_client ? (
                                                    <Avatar 
                                                        name={item?.name} 
                                                        width={'100%'} 
                                                        height={'100%'} 
                                                        fontSize={'1.5rem'} 
                                                    />
                                                ) : (
                                                    <RiContactsBook2Line />
                                                )}
                                            </span>
                                        </span>
                                        <span className='info--'>
                                            <span className='name'>
                                                {item?.nome ? item.nome : item.name}
                                            </span>
                                            <span className='description'>
                                                {item?.number_client ? 
                                                    item?.number_client : 
                                                    (item?.descricao ? item?.descricao : '...')
                                                }
                                            </span>
                                        </span>
                                    </li>
                                ))
                            }
                        </Selected>
                    </div>
                </PreviewSend>
            ) : (
                <LoadingSend />
            )}
        </div>
    );
};

export default SendStep;